import PropTypes from 'prop-types';
import { withTranslation } from 'utils/with-i18next';
import { useInView } from 'lib/useInView';
import { Store, Building2, PartyPopper } from 'lucide-react';

const USE_CASES = [
  {
    id: 'retail',
    icon: Store,
    titleKey: 'useCases.retail.title',
    descKey: 'useCases.retail.desc',
  },
  {
    id: 'office',
    icon: Building2,
    titleKey: 'useCases.office.title',
    descKey: 'useCases.office.desc',
  },
  {
    id: 'event',
    icon: PartyPopper,
    titleKey: 'useCases.event.title',
    descKey: 'useCases.event.desc',
  },
];

const UseCasesSection = ({ t }) => {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  return (
    <section className="py-24 md:py-32 bg-gradient-to-b from-background to-gray-900/50" ref={ref}>
      <div className={`max-w-6xl mx-auto px-6 md:px-12 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('useCases.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            {t('useCases.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {USE_CASES.map((useCase, index) => {
            const Icon = useCase.icon;
            return (
              <div
                key={useCase.id}
                className="group bg-gradient-to-br from-gray-900/90 to-gray-900/50 rounded-2xl p-8 border border-gray-800 hover:border-primary/50 transition-all duration-300 backdrop-blur-sm shadow-xl hover:shadow-2xl hover:shadow-primary/10 hover:-translate-y-1"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="w-16 h-16 bg-gradient-to-br from-primary/20 to-primary/5 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 border border-primary/10">
                  <Icon className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">
                  {t(useCase.titleKey)}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {t(useCase.descKey)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

UseCasesSection.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('index')(UseCasesSection);
